import { useLoaderData, Await } from "react-router-dom"
import { Suspense } from "react"


import FavoritesLanding from "../components/account/Favorites"
import LoadingWrapperAuth from "../components/common/LoadingWrapperAuth"
import AccountWrapper from "../components/common/AccountWrapper"

const Favorites = () => {
    const data = useLoaderData() 
     
    return <Suspense fallback={<LoadingWrapperAuth text=""/>}>
        <Await resolve={data.data}>
            {() => <>
                <AccountWrapper>
                    <FavoritesLanding/>
                </AccountWrapper>
            </>}
        </Await>
    </Suspense>
}

export default Favorites